import { successStories } from '../data/successStories';
import { useScrollReveal } from '../hooks/useScrollReveal';

const TestimonialCard = ({ story }) => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.15 });

  return (
    <article ref={ref} className={`testimonial-card fade-section ${isVisible ? 'is-visible' : ''}`}>
      <figure className="testimonial-media">
        <img src={story.image} alt={`Wedding website for ${story.couple}`} loading="lazy" />
      </figure>
      <div className="testimonial-content">
        <h3>{story.couple}</h3>
        {story.testimonial.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </article>
  );
};

export const SuccessStories = () => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="success-stories" className="section stories-section">
      <div className="container">
        <div ref={ref} className={`section-heading fade-section ${isVisible ? 'is-visible' : ''}`}>
          <span className="section-eyebrow">Success Stories</span>
          <h2>Real couples, real celebrations</h2>
          <p>See how Wedding Tech keeps every detail on-brand and stress-free from day one.</p>
        </div>
        <div className="stories-grid">
          {successStories.map((story) => (
            <TestimonialCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
};
